import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';
import { perfil } from '@domain/models/_profile';
import Swal from 'sweetalert2';
import { environment } from 'environments/environment';

@Injectable()
export class UserAccessService {
  public url: string;

  constructor(
    public _http: HttpClient
  ) {
    this.url = environment.useraccess + "acceso/";
  }

  obenerUsuarioPoIdUsuario(id: any) {
    let ruta = environment.catUserControl;
    return this._http.get(ruta + "" + "" + id);
  }

  findProfileByUser(idUser: string): Observable<any> {
    let ruta = `${this.url}findProfileById/${idUser}`;
    return this._http.get(ruta);
  }

  validarVigenciaUsuarioPoIdUsuario(id: any): Observable<any> {
    let ruta = environment.catUserControl;
    return this._http.post(ruta + "validaVigencia/" + id, {}).pipe(
      catchError(err => of(err))
    );
  }

  findAll(): Observable<any> {
    let ruta = `${this.url}findAll`;
    return this._http.get(ruta);
  }

  findById(cadena: string): Observable<any> {
    let ruta = `${this.url}findBy?${cadena}`;
    return this._http.get(ruta);
  }

  deleteById(cadena: string): Observable<any> {
    let ruta = `${this.url}delete/${cadena}`;
    return this._http.delete(ruta);
  }

  save(form: any): Observable<any> {
    let params = JSON.stringify(form);
    let headersResp = new HttpHeaders().set('Content-Type', 'application/json');
    return this._http.post<any>(`${this.url}save`, params, { headers: headersResp }).pipe(
      catchError(err => of(err))
    );
  }

  update(form: any): Observable<any> {
    let params = JSON.stringify(form);
    let headersResp = new HttpHeaders().set('Content-Type', 'application/json');
    return this._http.put(`${this.url}update`, params, { headers: headersResp }).pipe(
      catchError(err => of(err))
    );;
  }

  findAllRol(): Observable<any> {
    let ruta = `${this.url}findAllRol`;
    return this._http.get(ruta);
  }

  obtenerPerfilYPermiso(idUser: any): Observable<any> {
    let ruta = `${this.url}findProfileById/` + idUser;
    return this._http.get(ruta, {
      headers: new HttpHeaders(
        {
          'Content-Type': 'application/json'
        })
    }).pipe(
      catchError(err => of(err)),
      tap(response => {
        if (response) {
          response.forEach((item: any) => {

            // -------- Para USUARIO -----------
            if (perfil.usuario.id_user === "") { perfil.usuario.id_user = item.id_user; }
            if (perfil.usuario.nombre === "") { perfil.usuario.nombre = item.nombre; }
            if (perfil.usuario.ap_paterno === "") { perfil.usuario.ap_paterno = item.ap_paterno; }
            if (perfil.usuario.ap_materno === "") { perfil.usuario.ap_materno = item.ap_materno; }
            if (perfil.usuario.email === "") { perfil.usuario.email = item.email; }

            // -------- Para PERMISOS -----------
            if (item.producto === "MaestroSocios") {
              if (item.funcion === "Editar") {
                perfil.permisos.MaestroSocios.edicion = true;
              }
              if (item.funcion === "Consulta") {
                perfil.permisos.MaestroSocios.consulta = true;
              }
              if (item.funcion === "Reportes") {
                perfil.permisos.MaestroSocios.reportes = true;
              }
              if (item.funcion === "Borrar") {
                perfil.permisos.MaestroSocios.borrar = true;
              }
            }
            if (item.producto === "MantPrecioCompo") {
              if (item.funcion === "Editar") {
                perfil.permisos.MantPrecioCompo.edicion = true;
              }
              if (item.funcion === "Consulta") {
                perfil.permisos.MantPrecioCompo.consulta = true;
              }
              if (item.funcion === "Reportes") {
                perfil.permisos.MantPrecioCompo.reportes = true;
              }
              if (item.funcion === "Borrar") {
                perfil.permisos.MantPrecioCompo.borrar = true;
              }
            }
            if (item.producto === "PrecioPromSem") {
              if (item.funcion === "Editar") {
                perfil.permisos.PrecioPromSem.edicion = true;
              }
              if (item.funcion === "Consulta") {
                perfil.permisos.PrecioPromSem.consulta = true;
              }
              if (item.funcion === "Reportes") {
                perfil.permisos.PrecioPromSem.reportes = true;
              }
              if (item.funcion === "Borrar") {
                perfil.permisos.PrecioPromSem.borrar = true;
              }
            }
            if (item.producto === "PrecioFijoSem") {
              if (item.funcion === "Editar") {
                perfil.permisos.PrecioFijoSem.edicion = true;
              }
              if (item.funcion === "Consulta") {
                perfil.permisos.PrecioFijoSem.consulta = true;
              }
              if (item.funcion === "Reportes") {
                perfil.permisos.PrecioFijoSem.reportes = true;
              }
              if (item.funcion === "Borrar") {
                perfil.permisos.PrecioFijoSem.borrar = true;
              }
            }
            if (item.producto === "PrecioFijoVig") {
              if (item.funcion === "Editar") {
                perfil.permisos.PrecioFijoVig.edicion = true;
              }
              if (item.funcion === "Consulta") {
                perfil.permisos.PrecioFijoVig.consulta = true;
              }
              if (item.funcion === "Reportes") {
                perfil.permisos.PrecioFijoVig.reportes = true;
              }
              if (item.funcion === "Borrar") {
                perfil.permisos.PrecioFijoVig.borrar = true;
              }
            }
            if (item.producto === "MantAcciones") {
              if (item.funcion === "Editar") {
                perfil.permisos.MantAcciones.edicion = true;
              }
              if (item.funcion === "Consulta") {
                perfil.permisos.MantAcciones.consulta = true;
              }
              if (item.funcion === "Reportes") {
                perfil.permisos.MantAcciones.reportes = true;
              }
              if (item.funcion === "Borrar") {
                perfil.permisos.MantAcciones.borrar = true;
              }
            }
            if (item.producto === "MantContratos") {
              if (item.funcion === "Editar") {
                perfil.permisos.MantContratos.edicion = true;
              }
              if (item.funcion === "Consulta") {
                perfil.permisos.MantContratos.consulta = true;
              }
              if (item.funcion === "Reportes") {
                perfil.permisos.MantContratos.reportes = true;
              }
              if (item.funcion === "Borrar") {
                perfil.permisos.MantContratos.borrar = true;
              }
            }
            if (item.producto === "MantLitrosAcciones") {
              if (item.funcion === "Editar") {
                perfil.permisos.MantLitrosAcciones.edicion = true;
              }
              if (item.funcion === "Consulta") {
                perfil.permisos.MantLitrosAcciones.consulta = true;
              }
              if (item.funcion === "Reportes") {
                perfil.permisos.MantLitrosAcciones.reportes = true;
              }
              if (item.funcion === "Borrar") {
                perfil.permisos.MantLitrosAcciones.borrar = true;
              }
            }
            if (item.producto === "TopesDia") {
              if (item.funcion === "Editar") {
                perfil.permisos.TopesDia.edicion = true;
              }
              if (item.funcion === "Consulta") {
                perfil.permisos.TopesDia.consulta = true;
              }
              if (item.funcion === "Reportes") {
                perfil.permisos.TopesDia.reportes = true;
              }
              if (item.funcion === "Borrar") {
                perfil.permisos.TopesDia.borrar = true;
              }
            }
            if (item.producto === "TopesSemana") {
              if (item.funcion === "Editar") {
                perfil.permisos.TopesSemana.edicion = true;
              }
              if (item.funcion === "Consulta") {
                perfil.permisos.TopesSemana.consulta = true;
              }
              if (item.funcion === "Reportes") {
                perfil.permisos.TopesSemana.reportes = true;
              }
              if (item.funcion === "Borrar") {
                perfil.permisos.TopesSemana.borrar = true;
              }
            }
            if (item.producto === "FormulasCalidad") {
              if (item.funcion === "Editar") {
                perfil.permisos.FormulasCalidad.edicion = true;
              }
              if (item.funcion === "Consulta") {
                perfil.permisos.FormulasCalidad.consulta = true;
              }
              if (item.funcion === "Reportes") {
                perfil.permisos.FormulasCalidad.reportes = true;
              }
              if (item.funcion === "Borrar") {
                perfil.permisos.FormulasCalidad.borrar = true;
              }
            }
            if (item.producto === "Bancos") {
              if (item.funcion === "Editar") {
                perfil.permisos.Bancos.edicion = true;
              }
              if (item.funcion === "Consulta") {
                perfil.permisos.Bancos.consulta = true;
              }
              if (item.funcion === "Reportes") {
                perfil.permisos.Bancos.reportes = true;
              }
              if (item.funcion === "Borrar") {
                perfil.permisos.Bancos.borrar = true;
              }
            }
            if (item.producto === "Rutas") {
              if (item.funcion === "Editar") {
                perfil.permisos.Rutas.edicion = true;
              }
              if (item.funcion === "Consulta") {
                perfil.permisos.Rutas.consulta = true;
              }
              if (item.funcion === "Reportes") {
                perfil.permisos.Rutas.reportes = true;
              }
              if (item.funcion === "Borrar") {
                perfil.permisos.Rutas.borrar = true;
              }
            }
            if (item.producto === "Sucursales") {
              if (item.funcion === "Editar") {
                perfil.permisos.Sucursales.edicion = true;
              }
              if (item.funcion === "Consulta") {
                perfil.permisos.Sucursales.consulta = true;
              }
              if (item.funcion === "Reportes") {
                perfil.permisos.Sucursales.reportes = true;
              }
              if (item.funcion === "Borrar") {
                perfil.permisos.Sucursales.borrar = true;
              }
            }
            if (item.producto === "Tanques") {
              if (item.funcion === "Editar") {
                perfil.permisos.Tanques.edicion = true;
              }
              if (item.funcion === "Consulta") {
                perfil.permisos.Tanques.consulta = true;
              }
              if (item.funcion === "Reportes") {
                perfil.permisos.Tanques.reportes = true;
              }
              if (item.funcion === "Borrar") {
                perfil.permisos.Tanques.borrar = true;
              }
            }
            if (item.producto === "Veterinarios") {
              if (item.funcion === "Editar") {
                perfil.permisos.Veterinarios.edicion = true;
              }
              if (item.funcion === "Consulta") {
                perfil.permisos.Veterinarios.consulta = true;
              }
              if (item.funcion === "Reportes") {
                perfil.permisos.Veterinarios.reportes = true;
              }
              if (item.funcion === "Borrar") {
                perfil.permisos.Veterinarios.borrar = true;
              }
            }
            if (item.producto === "Plantas") {
              if (item.funcion === "Editar") {
                perfil.permisos.Plantas.edicion = true;
              }
              if (item.funcion === "Consulta") {
                perfil.permisos.Plantas.consulta = true;
              }
              if (item.funcion === "Reportes") {
                perfil.permisos.Plantas.reportes = true;
              }
              if (item.funcion === "Borrar") {
                perfil.permisos.Plantas.borrar = true;
              }
            }
            if (item.producto === "TipoDesvios") {
              if (item.funcion === "Editar") {
                perfil.permisos.TipoDesvios.edicion = true;
              }
              if (item.funcion === "Consulta") {
                perfil.permisos.TipoDesvios.consulta = true;
              }
              if (item.funcion === "Reportes") {
                perfil.permisos.TipoDesvios.reportes = true;
              }
              if (item.funcion === "Borrar") {
                perfil.permisos.TipoDesvios.borrar = true;
              }
            }
            if (item.producto === "RelPago") {
              if (item.funcion === "Editar") {
                perfil.permisos.RelPago.edicion = true;
              }
              if (item.funcion === "Consulta") {
                perfil.permisos.RelPago.consulta = true;
              }
              if (item.funcion === "Reportes") {
                perfil.permisos.RelPago.reportes = true;
              }
              if (item.funcion === "Borrar") {
                perfil.permisos.RelPago.borrar = true;
              }
            }
            if (item.producto === "Conceptos") {
              if (item.funcion === "Editar") {
                perfil.permisos.Conceptos.edicion = true;
              }
              if (item.funcion === "Consulta") {
                perfil.permisos.Conceptos.consulta = true;
              }
              if (item.funcion === "Reportes") {
                perfil.permisos.Conceptos.reportes = true;
              }
              if (item.funcion === "Borrar") {
                perfil.permisos.Conceptos.borrar = true;
              }
            }
            if (item.producto === "ControlConcepCia") {
              if (item.funcion === "Editar") {
                perfil.permisos.ControlConcepCia.edicion = true;
              }
              if (item.funcion === "Consulta") {
                perfil.permisos.ControlConcepCia.consulta = true;
              }
              if (item.funcion === "Reportes") {
                perfil.permisos.ControlConcepCia.reportes = true;
              }
              if (item.funcion === "Borrar") {
                perfil.permisos.ControlConcepCia.borrar = true;
              }
            }
            if (item.producto === "CompTransportistas") {
              if (item.funcion === "Editar") {
                perfil.permisos.CompTransportistas.edicion = true;
              }
              if (item.funcion === "Consulta") {
                perfil.permisos.CompTransportistas.consulta = true;
              }
              if (item.funcion === "Reportes") {
                perfil.permisos.CompTransportistas.reportes = true;
              }
              if (item.funcion === "Borrar") {
                perfil.permisos.CompTransportistas.borrar = true;
              }
            }
            if (item.producto === "MovRecoleccion") {
              if (item.funcion === "Editar") {
                perfil.permisos.MovRecoleccion.edicion = true;
              }
              if (item.funcion === "Consulta") {
                perfil.permisos.MovRecoleccion.consulta = true;
              }
              if (item.funcion === "Reportes") {
                perfil.permisos.MovRecoleccion.reportes = true;
              }
              if (item.funcion === "Borrar") {
                perfil.permisos.MovRecoleccion.borrar = true;
              }
            }
            if (item.producto === "AgrupRutasMovRecol") {
              if (item.funcion === "Editar") {
                perfil.permisos.AgrupRutasMovRecol.edicion = true;
              }
              if (item.funcion === "Consulta") {
                perfil.permisos.AgrupRutasMovRecol.consulta = true;
              }
              if (item.funcion === "Reportes") {
                perfil.permisos.AgrupRutasMovRecol.reportes = true;
              }
              if (item.funcion === "Borrar") {
                perfil.permisos.AgrupRutasMovRecol.borrar = true;
              }
            }
            if (item.producto === "ConcFactSocios") {
              if (item.funcion === "Editar") {
                perfil.permisos.ConcFactSocios.edicion = true;
              }
              if (item.funcion === "Consulta") {
                perfil.permisos.ConcFactSocios.consulta = true;
              }
              if (item.funcion === "Reportes") {
                perfil.permisos.ConcFactSocios.reportes = true;
              }
              if (item.funcion === "Borrar") {
                perfil.permisos.ConcFactSocios.borrar = true;
              }
            }
            if (item.producto === "GrupAparcerias") {
              if (item.funcion === "Editar") {
                perfil.permisos.GrupAparcerias.edicion = true;
              }
              if (item.funcion === "Consulta") {
                perfil.permisos.GrupAparcerias.consulta = true;
              }
              if (item.funcion === "Reportes") {
                perfil.permisos.GrupAparcerias.reportes = true;
              }
              if (item.funcion === "Borrar") {
                perfil.permisos.GrupAparcerias.borrar = true;
              }
            }
            if (item.producto === "RegionesRecol") {
              if (item.funcion === "Editar") {
                perfil.permisos.RegionesRecol.edicion = true;
              }
              if (item.funcion === "Consulta") {
                perfil.permisos.RegionesRecol.consulta = true;
              }
              if (item.funcion === "Reportes") {
                perfil.permisos.RegionesRecol.reportes = true;
              }
              if (item.funcion === "Borrar") {
                perfil.permisos.RegionesRecol.borrar = true;
              }
            }
            if (item.producto === "GrupArrendamientos") {
              if (item.funcion === "Editar") {
                perfil.permisos.GrupArrendamientos.edicion = true;
              }
              if (item.funcion === "Consulta") {
                perfil.permisos.GrupArrendamientos.consulta = true;
              }
              if (item.funcion === "Reportes") {
                perfil.permisos.GrupArrendamientos.reportes = true;
              }
              if (item.funcion === "Borrar") {
                perfil.permisos.GrupArrendamientos.borrar = true;
              }
            }
            if (item.producto === "ContSirla") {
              if (item.funcion === "Editar") {
                perfil.permisos.ContSirla.edicion = true;
              }
              if (item.funcion === "Consulta") {
                perfil.permisos.ContSirla.consulta = true;
              }
              if (item.funcion === "Reportes") {
                perfil.permisos.ContSirla.reportes = true;
              }
              if (item.funcion === "Borrar") {
                perfil.permisos.ContSirla.borrar = true;
              }
            }
            if (item.producto === "TablaCompensaciónLog") {
              if (item.funcion === "Editar") {
                perfil.permisos.TablaCompensacionLog.edicion = true;
              }
              if (item.funcion === "Consulta") {
                perfil.permisos.TablaCompensacionLog.consulta = true;
              }
              if (item.funcion === "Reportes") {
                perfil.permisos.TablaCompensacionLog.reportes = true;
              }
              if (item.funcion === "Borrar") {
                perfil.permisos.TablaCompensacionLog.borrar = true;
              }
            }
            if (item.producto === "MantClaseA") {
              if (item.funcion === "Editar") {
                perfil.permisos.MantClaseA.edicion = true;
              }
              if (item.funcion === "Consulta") {
                perfil.permisos.MantClaseA.consulta = true;
              }
              if (item.funcion === "Reportes") {
                perfil.permisos.MantClaseA.reportes = true;
              }
              if (item.funcion === "Borrar") {
                perfil.permisos.MantClaseA.borrar = true;
              }
            }
            if (item.producto === "Capturas") {
              if (item.funcion === "Editar") {
                perfil.permisos.Capturas.edicion = true;
              }
              if (item.funcion === "Consulta") {
                perfil.permisos.Capturas.consulta = true;
              }
              if (item.funcion === "Reportes") {
                perfil.permisos.Capturas.reportes = true;
              }
              if (item.funcion === "Borrar") {
                perfil.permisos.Capturas.borrar = true;
              }
            }
            if (item.producto === "Reportes") {
              if (item.funcion === "Editar") {
                perfil.permisos.Reportes.edicion = true;
              }
              if (item.funcion === "Consulta") {
                perfil.permisos.Reportes.consulta = true;
              }
              if (item.funcion === "Reportes") {
                perfil.permisos.Reportes.reportes = true;
              }
              if (item.funcion === "Borrar") {
                perfil.permisos.Reportes.borrar = true;
              }
            }
            if (item.producto === "AnLecheTanque") {
              if (item.funcion === "Editar") {
                perfil.permisos.AnLecheTanque.edicion = true;
              }
              if (item.funcion === "Consulta") {
                perfil.permisos.AnLecheTanque.consulta = true;
              }
              if (item.funcion === "Reportes") {
                perfil.permisos.AnLecheTanque.reportes = true;
              }
              if (item.funcion === "Borrar") {
                perfil.permisos.AnLecheTanque.borrar = true;
              }
            }
            if (item.producto === "Procesos") {
              if (item.funcion === "Editar") {
                perfil.permisos.Procesos.edicion = true;
              }
              if (item.funcion === "Consulta") {
                perfil.permisos.Procesos.consulta = true;
              }
              if (item.funcion === "Reportes") {
                perfil.permisos.Procesos.reportes = true;
              }
              if (item.funcion === "Borrar") {
                perfil.permisos.Procesos.borrar = true;
              }
            }
            if (item.producto === "CargaMilkoScan") {
              if (item.funcion === "Editar") {
                perfil.permisos.CargaMilkoScan.edicion = true;
              }
              if (item.funcion === "Consulta") {
                perfil.permisos.CargaMilkoScan.consulta = true;
              }
              if (item.funcion === "Reportes") {
                perfil.permisos.CargaMilkoScan.reportes = true;
              }
              if (item.funcion === "Borrar") {
                perfil.permisos.CargaMilkoScan.borrar = true;
              }
            }
            if (item.producto === "CargaColLPC") {
              if (item.funcion === "Editar") {
                perfil.permisos.CargaColLPC.edicion = true;
              }
              if (item.funcion === "Consulta") {
                perfil.permisos.CargaColLPC.consulta = true;
              }
              if (item.funcion === "Reportes") {
                perfil.permisos.CargaColLPC.reportes = true;
              }
              if (item.funcion === "Borrar") {
                perfil.permisos.CargaColLPC.borrar = true;
              }
            }
            if (item.producto === "Consultas") {
              if (item.funcion === "Editar") {
                perfil.permisos.Consultas.edicion = true;
              }
              if (item.funcion === "Consulta") {
                perfil.permisos.Consultas.consulta = true;
              }
              if (item.funcion === "Reportes") {
                perfil.permisos.Consultas.reportes = true;
              }
              if (item.funcion === "Borrar") {
                perfil.permisos.Consultas.borrar = true;
              }
            }
            if (item.producto === "DirSocios") {
              if (item.funcion === "Editar") {
                perfil.permisos.DirSocios.edicion = true;
              }
              if (item.funcion === "Consulta") {
                perfil.permisos.DirSocios.consulta = true;
              }
              if (item.funcion === "Reportes") {
                perfil.permisos.DirSocios.reportes = true;
              }
              if (item.funcion === "Borrar") {
                perfil.permisos.DirSocios.borrar = true;
              }
            }
            if (item.producto === "Deducciones") {
              if (item.funcion === "Editar") {
                perfil.permisos.Deducciones.edicion = true;
              }
              if (item.funcion === "Consulta") {
                perfil.permisos.Deducciones.consulta = true;
              }
              if (item.funcion === "Reportes") {
                perfil.permisos.Deducciones.reportes = true;
              }
              if (item.funcion === "Borrar") {
                perfil.permisos.Deducciones.borrar = true;
              }
            }
            if (item.producto === "Contabilidad") {
              if (item.funcion === "Editar") {
                perfil.permisos.Contabilidad.edicion = true;
              }
              if (item.funcion === "Consulta") {
                perfil.permisos.Contabilidad.consulta = true;
              }
              if (item.funcion === "Reportes") {
                perfil.permisos.Contabilidad.reportes = true;
              }
              if (item.funcion === "Borrar") {
                perfil.permisos.Contabilidad.borrar = true;
              }
            }
            if (item.producto === "ProcCrioscopia") {
              if (item.funcion === "Editar") {
                perfil.permisos.ProcCrioscopia.edicion = true;
              }
              if (item.funcion === "Consulta") {
                perfil.permisos.ProcCrioscopia.consulta = true;
              }
              if (item.funcion === "Reportes") {
                perfil.permisos.ProcCrioscopia.reportes = true;
              }
              if (item.funcion === "Borrar") {
                perfil.permisos.ProcCrioscopia.borrar = true;
              }
            }
            if (item.producto === "Accesos") {
              if (item.funcion === "Editar") {
                perfil.permisos.Accesos.edicion = true;
              }
              if (item.funcion === "Consulta") {
                perfil.permisos.Accesos.consulta = true;
              }
              if (item.funcion === "Reportes") {
                perfil.permisos.Accesos.reportes = true;
              }
              if (item.funcion === "Borrar") {
                perfil.permisos.Accesos.borrar = true;
              }
            }
            if (item.producto === "Usuarios") {
              if (item.funcion === "Editar") {
                perfil.permisos.Usuarios.edicion = true;
              }
              if (item.funcion === "Consulta") {
                perfil.permisos.Usuarios.consulta = true;
              }
              if (item.funcion === "Reportes") {
                perfil.permisos.Usuarios.reportes = true;
              }
              if (item.funcion === "Borrar") {
                perfil.permisos.Usuarios.borrar = true;
              }
            }
            if (item.producto === "Perfiles") {
              if (item.funcion === "Editar") {
                perfil.permisos.Perfiles.edicion = true;
              }
              if (item.funcion === "Consulta") {
                perfil.permisos.Perfiles.consulta = true;
              }
              if (item.funcion === "Reportes") {
                perfil.permisos.Perfiles.reportes = true;
              }
              if (item.funcion === "Borrar") {
                perfil.permisos.Perfiles.borrar = true;
              }
            }
            if (item.producto === "JuegoVal") {
              if (item.funcion === "Editar") {
                perfil.permisos.JuegoVal.edicion = true;
              }
              if (item.funcion === "Consulta") {
                perfil.permisos.JuegoVal.consulta = true;
              }
              if (item.funcion === "Reportes") {
                perfil.permisos.JuegoVal.reportes = true;
              }
              if (item.funcion === "Borrar") {
                perfil.permisos.JuegoVal.borrar = true;
              }
            }
          });
        } else {
          Swal.fire({ icon: 'error', title: 'Sin información para usuario ' + idUser, html: `<b>ERR00</b><br><br><em class='fa fa-info-circle'></em>&nbsp; No se pudo recuperar el perfil del usuario` });
          // habilitar para cerrar sesión automáticamente
        }


        localStorage.setItem('permisos', JSON.stringify(perfil.permisos));
        localStorage.setItem('usuario', JSON.stringify(perfil.usuario));
      })
    );
  }
}
